import React from 'react';
import { useTranslate } from '../../../contexts/languageContext';
import { usePage } from '../../../contexts/pageContext';
import { useNomenclator } from '../../../contexts/nomenclatorContext';
import RankingStats from '../../../containers/RankingStats';
import EstadisticasRankingPartidos from '../../components/EstadisticasRankingPartidos';
import EstadisticasConsolidado from '../../components/EstadisticasConsolidado';

import { HeaderEstadisticas } from '../../components/Header';
import PrintStyles from '../../components/estilos';
import Footer from '../../../components/Footer/Footer';
import styled from 'styled-components/macro';

export default function Estadisticas() {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const { data, urlInfo } = pageState;
  const {
    page,
    elec,
    tipoEst,
    tipoDato,
    setElec,
    setTipoEst,
    setTipoDato,
  } = urlInfo;

  const title = tipo => {
    let titulo;
    switch (tipo) {
      case 'VV':
        titulo = t('votos') + ' ' + t('validos').toLowerCase();
        break;
      case 'VN':
        titulo = t('votos') + ' ' + t('nulos').toLowerCase();
        break;
      case 'VB':
        titulo = t('votos') + ' ' + t('enBlanco').toLowerCase();
        break;
      case 'NM':
        titulo = t('tarjNoMarc');
        break;
      case 'AB':
        titulo = t('abstencion');
        break;
      case 'VP':
        titulo = t('votacionXPart');
        break;
      case 'PA':
      case 'VT':
        titulo = t('participacion');
        break;
        throw new Error();
    }
    return titulo;
  };

  const textoInicial = tipoEst === 'C' ? 'consolidado' : 'ranking';
  let datosConsolidados = [
    { tipo: tipoDato, nombre: title(tipoDato), data: [data] }
  ];

  return (
    <>
      <PrintStyles />
      <div className="pdfPrint">
        <HeaderEstadisticas elec={elec} nomenclator={nomenclator} />
        <div className="main">
        <Title>{t(textoInicial) + ' ' + title(tipoDato)}</Title>
          <ContainerTabla>
            {tipoEst === 'C' ? (
              <EstadisticasConsolidado data={datosConsolidados} />
            ) : (
              tipoDato === 'VP' ? (
                <EstadisticasRankingPartidos
                  data={datosConsolidados}
                  nomenclator={nomenclator}
                />
              ) : (
                <RankingStats
                  tipo={tipoDato}
                  title={title(tipoDato)}
                  elec={elec}
                  data={data}
                  nomenclator={nomenclator}
                />
              )
            )}
          </ContainerTabla>
        </div>
        <Footer />
      </div>
    </>
  );
}

const ContainerTabla = styled.div`
  margin-top: 6px;
  background-color: white;
  box-shadow: 0px -7px 18px rgb(0 0 0 / 6%);
  overflow: auto;
  border: 5px solid white;
  // @media (max-width: 768px) {
  //   margin-top: 12px;
  }
`;

const Title = styled.h3`
  font-weight: bold;
  text-transform: uppercase;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #222222;
`;
